<template>
  <el-row class="countries" :gutter="10">
    <el-col
      v-for="row in data"
      :key="row.name"
      :span="6"
    >
      <el-button
        type="default"
        v-bind:class="{ selected: country && row.name === country.name }"
        :style="{ backgroundImage: 'url('+ row.flag +')' }"
        @click="$emit('update:country', row)"
      >
        {{ row.name }}
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import { countries } from 'countries-list'

export default {
  props: {
    country: {
      type: Object,
      default: null
    }
  },
  computed: {
    data () {
      const data = []

      this.plans.filter((p) => p.active).forEach((plan) => {
        let country = plan.region.country
        if (country === 'UK') {
          country = 'GB'
        }
        if (!countries[country]) {
          return
        }

        const name = countries[country].name
        let index = data.findIndex((r) => r.name === name)
        if (index === -1) {
          index = data.length
        }

        const plans = data[index] ? data[index].plans : []
        this.$set(data, index, {
          plans,
          name,
          country: plan.region.country,
          flag: '/flags/' + plan.region.country + '.png'
        })

        data[index].plans.push(plan)
        data.sort((a, b) => a.name.localeCompare(b.name))
      })

      data.forEach((country) => {
        country.plans.sort((a, b) => parseInt(a.price.month) - parseInt(b.price.month))
      })
      return data
    }
  },
  watch: {
    country (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-button--default {
    text-align: left;
    background-position: center left 16px;
    background-repeat: no-repeat;
    background-size: 25px;
    padding-left: 52px;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    color: $--color-text-primary;
    border-color: $--border-color-base;
    width: 100%;
    margin: 10px 0;

    &.selected {
      border: 1px solid $--color-primary;
      box-shadow: $--card-box-shadow-small !important;
    }
  }
</style>
